import { render, staticRenderFns } from "./GroupSurveyScheduledMails.vue?vue&type=template&id=0c64c2e0"
import script from "./GroupSurveyScheduledMails.vue?vue&type=script&lang=js"
export * from "./GroupSurveyScheduledMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports